export function assertDefined<V>(value: V | undefined | null): asserts value is V {
	if (value === undefined || value === null) {
		throw new Error('value should be defined')
	}
}
